export default __webpack_public_path__ + "static/media/307.e77888f6.png";